import { PhoneNumberDetails } from "./types";

const copy = {
  phoneNumbers: {
    displayValue: ({ country, number }: PhoneNumberDetails): string =>
      `${country}: ${number}`,
  },
  modalButton: "See support phone numbers",
  modalHeading: "Support Phone Numbers",
};

export default copy;
